import React, { useState, useEffect, useContext } from 'react'
import PropTypes from 'prop-types'

import { JumpLink } from '@aok/ui-elements'
import { ContextHeadline, TextBlock } from '@aok/text-elements'

import { EasyLanguagePageContext } from '../../../context/EasyLanguagePageContext'
import defaultProps from '../../../utils/propTypes/defaultProps'
import { BREAKPOINT_1000, BREAKPOINT_1280 } from '../../../utils/constants/breakpoints'
import { useWindowSize } from '../../../hooks/customHooks'

import SmallContentContainer from '../../_layouts/SmallContentContainer/SmallContentContainer'
import AllroundContainer from '../../_layouts/AllroundContainer'

const M046 = ({ abstract, jumpLinks }) => {
  const { isEasyLanguagePage } = useContext(EasyLanguagePageContext)
  const [scrollToOffset, setScrollToOffset] = useState(76)
  const [windowWidth] = useWindowSize()

  useEffect(() => {
    if (window.innerWidth < BREAKPOINT_1000) {
      setScrollToOffset(76)
    } else if (window.innerWidth < BREAKPOINT_1280) {
      setScrollToOffset(164)
    } else {
      setScrollToOffset(172)
    }
  }, [windowWidth])

  return (
    <AllroundContainer
      dataTrackingName="M046"
      className={`${isEasyLanguagePage ? 'bg-e8f4f2 py-48 600:py-64 1000:py-80 1280:w-full' : ''}`}
    >
      <SmallContentContainer isEasyLanguagePage={isEasyLanguagePage}>
        <ContextHeadline
          id="m046-headline"
          tag={abstract?.headline?.tag}
          text={abstract?.headline?.text}
          className={`font-semibold text-005e3f
          text-36 leading-44
          600:text-40
          1280:text-48
          ${isEasyLanguagePage ? 'accessibilityHeadline h2' : ' pb-16 600:leading-48 1280:leading-60'}
          ${/&shy/g.test(abstract?.headline?.text) ? '' : 'hyphens'}
        `}
        />
        <TextBlock
          text={abstract.text}
          className={`text-293033
          ${isEasyLanguagePage ? 'accessibilityParagraph mt-12 600:mt-8' : ' 600:ml-8 1000:ml-4 1000:mt-4 1280:ml-0'}
        `}
        />
        <ul
          aria-describedby="m046-headline"
          className={`mt-4  ${isEasyLanguagePage ? '600:ml-0' : '600:ml-8 1000:ml-4 1280:ml-8'}`}
        >
          {jumpLinks &&
            jumpLinks.map((jumpLink, index) => {
              return (
                <li key={index} className={`${isEasyLanguagePage ? 'mt-16' : 'mb-24 600:mb-16'}`}>
                  <JumpLink
                    offset={scrollToOffset}
                    iconPosition="left"
                    arrowDirection="down"
                    targetId={`#${jumpLink.id}`}
                    title={jumpLink.title}
                    contentAlign="start"
                    iconClassName="relative top-0"
                  />
                </li>
              )
            })}
        </ul>
      </SmallContentContainer>
    </AllroundContainer>
  )
}

M046.propTypes = {
  abstract: PropTypes.shape({
    headline: PropTypes.shape({
      text: PropTypes.string,
      tag: PropTypes.string,
    }),
    text: PropTypes.string,
  }),
  primaryContentLoaded: PropTypes.bool,
}

M046.defaultProps = {
  abstract: {
    headline: {
      text: defaultProps.HEADLINE,
    },
    text: defaultProps.DESCRIPTION_RICH,
  },
}

export default M046
